import * as React from "react";
import useSubscriptions from "@/hooks/useSubscriptions";
import Workflows from "./Workflows";
import WorkflowsLandingV2 from "./WorkflowsLandingV2";

export default function WorkflowsLandingGate() {
  const { subscription } = useSubscriptions();
  if (subscription?.enableNewWorkflowsUX) {
    return <WorkflowsLandingV2 />;
  }
  return <Workflows />;
}
